import { useTrpc } from '@repo/lib/trpc-context';
import type { GetOrderQuestionnairesInput } from '@repo/questionnaire';
import { useQuery } from '@tanstack/react-query';
import type { TRPCReactRequestOptions } from '@trpc/tanstack-react-query';

export const useOrderQuestionnaires = (
    params: GetOrderQuestionnairesInput,
    enabled: boolean,
    trpcOptions?: TRPCReactRequestOptions
) => {
    const trpc = useTrpc();

    return useQuery(
        trpc.questionnaire.get.queryOptions(params, {
            enabled,
            trpc: trpcOptions ?? {},
        })
    );
};
